import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import TextFieldOutlined from "../../components/common/TextFieldOutlined";
import UserContext from "../../context/user-context";
import useTabs from "../../hooks/useTabs";
import { useTranslation } from "../../hooks/useTranslation";
import { setFindCompanion } from "../../redux/actions/dataAction";
import { setBlackListAuthorization } from "../../store/actions/userAction";
import { blackListSchema } from "../../utils/validations/BlackListValidationSchema";

type DialogBlackListProps = {
  open: boolean;
  onConfirm?: () => void;
  onClose?: () => void;
};

const DialogBlackList = ({ open, onConfirm, onClose }: DialogBlackListProps) => {
  const [allowingEntry, setAllowingEntry] = useState(false);
  const { t, BundleKey } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(blackListSchema(t)),
  });
  const { state, dispatch } = useContext(UserContext);
  const globalDispatch = useDispatch();
  const [blackListAuthorizedBy, setBlackListAuthorizedBy] = useState("");
  const { onCloseTab } = useTabs();

  const onCancel = () => {
    if (onClose) onClose();
    if (!state.config?.companion) onCloseTab(state.indexTab);
    else globalDispatch(setFindCompanion("cancel"));
    setAllowingEntry(false);
  };

  const showOptions = () => {
    setAllowingEntry(true);
  };

  const onSubmit = () => {
    if (onConfirm) onConfirm();
    if (onClose) onClose();
    dispatch(setBlackListAuthorization(blackListAuthorizedBy));
    setAllowingEntry(false);
  };

  //onChange
  const handleChange = (value: string) => {
    setBlackListAuthorizedBy(value);
  };

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby="responsive-dialog-title">
      <DialogTitle id="alert-dialog-title">
        {t(BundleKey.BLACKLIST_DESCRIPTION, {
          dni: state.blacklistedData?.dni,
          responsable: state.blacklistedData?.blacklistedBy,
        })}
      </DialogTitle>
      <DialogContent>
        <Grid container direction="column" justifyContent="center" alignItems="center">
          <Grid item>
            <Grid container direction="column" justifyContent="center" alignItems="flex-start">
              <Grid item>
                <DialogContentText>
                  {t(BundleKey.BLACKLIST_NAME, {
                    name: state.blacklistedData?.firstname,
                  })}
                </DialogContentText>
              </Grid>

              <Grid item>
                <DialogContentText>
                  {t(BundleKey.BLACKLIST_LASTNAME, {
                    lastname: state.blacklistedData?.lastname,
                  })}
                </DialogContentText>
              </Grid>

              <Grid item>
                <DialogContentText>
                  {t(BundleKey.BLACKLIST_REASON, {
                    reason: state.blacklistedData?.reason,
                  })}
                </DialogContentText>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container direction="row" justifyContent="center" spacing={2}>
          <Grid item>
            <Button onClick={onCancel} color="primary" variant="outlined">
              {t(BundleKey.BLACKLIST_ACTION_REJECT)}
            </Button>
          </Grid>
          <Grid item>
            <Button onClick={showOptions} variant="contained" color="primary">
              {t(BundleKey.BLACKLIST_ACTION_ACCEPT)}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
      <DialogContent>
        {allowingEntry ? (
          <form noValidate onSubmit={handleSubmit(() => onSubmit())}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12} sm={8}>
                <TextFieldOutlined
                  name="blacklistAuthorization"
                  type="text"
                  label={t(BundleKey.BLACKLIST_AUTHORIZED_PLACEHOLDER)}
                  onChange={(value) => handleChange(value)}
                  registration={register("blacklistAuthorization")}
                  errors={errors.blacklistAuthorization?.message}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <Button type="submit" fullWidth color="primary" variant="contained">
                  {t(BundleKey.BLACKLIST_ACTION_CONFIRM)}
                </Button>
              </Grid>
            </Grid>
          </form>
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default DialogBlackList;
